import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { CreamJar, Sprig } from './Decor';
const points: {
  problem: string;
  result: string;
}[] = [{
  problem: 'No sé qué receta usar',
  result: 'Improviso fórmulas de Instagram sin garantía de resultados'
}, {
  problem: 'No calculo mis costos',
  result: 'Creo que gano $500 por unidad cuando en realidad pierdo plata'
}, {
  problem: 'Mis productos se ven “caseros”',
  result: 'No me compran. No me toman en serio como marca profesional'
}, {
  problem: 'No sé cómo vender',
  result: 'Dependo de que la gente me encuentre. No cierro ventas activamente'
}, {
  problem: 'Fabrico sin sistema',
  result: 'Cada lote sale distinto. Mis clientes notan la variación'
}, {
  problem: 'No monetizo mis redes',
  result: 'Tengo 5.000 seguidores pero vendo 2 unidades por mes'
}];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-281" data-mp="3ncfo2j8cmj55">
      <div className="relative overflow-hidden rounded-3xl border border-brand-rose/30 bg-brand-roseMist/60 p-6 md:p-10" data-id="element-282" data-mp="3nbd0ola8iytz">
        <Sprig aria-hidden="true" className="pointer-events-none absolute -right-6 -top-6 h-56 w-32 text-brand-rose/20" data-id="element-283" data-mp="1yyu30znvpd5v" />
        <div className="relative" data-id="element-284" data-mp="27t8ip3cbmppi">
          <h2 className="mb-8 text-center font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-285" data-mp="27sh0cu7qioh6">
            ❌ LO QUE PASA SIN LA GUÍA DEFINITIVA
          </h2>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-286" data-mp="1g11408gdlndr">
            {points.map(point => <li key={point.problem} className="rounded-xl border-l-4 border-brand-rose bg-white p-5" data-id="element-287" data-mp="1b399d6ocjn5v">
                <p className="mb-1.5 flex items-start gap-2 text-sm font-bold text-brand-taupe" data-id="element-288" data-mp="1p2r4s4w5dyo7">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-rose" data-id="element-289" data-mp="1k34r5uceqgev" />
                  {point.problem}
                </p>
                <p className="pl-6 text-sm leading-relaxed text-brand-muted" data-id="element-290" data-mp="30g31zwxejj1e">→ {point.result}</p>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="relative mt-12 overflow-hidden rounded-3xl border-2 border-brand-gold/50 bg-brand-parchment p-8 text-center md:p-12" data-id="element-291" data-mp="1t5y7qhy0091f">
        <CreamJar aria-hidden="true" className="pointer-events-none absolute -left-4 bottom-2 hidden h-28 w-28 text-brand-sageMist md:block" data-id="element-292" data-mp="1y2eyzl0hv3iq" />
        <div className="relative" data-id="element-293" data-mp="273v53gka0jh5">
          <h3 className="font-serif text-2xl font-bold leading-tight text-brand-taupe md:text-4xl" data-id="element-294" data-mp="272tufd769yzy">
            ¿Y si esta fuera la última vez que improvisás?
          </h3>
          <div className="mx-auto mt-5 max-w-2xl space-y-4 text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-295" data-mp="1egscf52a72yt">
            <p data-id="element-296" data-mp="1jd905y5kjfbd">
              Imaginá que tu próxima tandada de productos sale perfecta. Con receta exacta. Con costos calculados. Con
              packaging que enamora. Con copy que cierra ventas.
            </p>
            <p data-id="element-297" data-mp="qotw26nz6het">Imaginá tener un sistema donde cada paso está documentado, probado y listo para aplicar.</p>
            <p className="font-semibold text-brand-sageMid" data-id="element-298" data-mp="o68c4uo1urhv">Eso es exactamente lo que vas a tener con este pack.</p>
          </div>
        </div>
      </div>
    </Section>;
}